import { motion } from "framer-motion";
import { Globe } from "lucide-react";

interface Props {
  marketCode: string;
}

export default function MarketFallbackBanner({ marketCode }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="max-w-xl mx-auto mb-3 px-4 py-2.5 rounded-lg border border-border/40 bg-muted/20 text-center"
    >
      <div className="flex items-center justify-center gap-2">
        <Globe className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
        <p className="text-[11px] text-muted-foreground font-body">
          Limited local coverage for {marketCode}. Results may rely on US/global market data.
        </p>
      </div>
    </motion.div>
  );
}
